import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Eye, X } from "lucide-react";
import { toast } from "sonner";

export const ImpersonationBanner = () => {
  const { impersonator, user, exitViewAs } = useAuth();
  const navigate = useNavigate();
  if (!impersonator) return null;

  const exit = async () => {
    try {
      await exitViewAs();
      toast.success("Exited access preview");
      navigate("/users");
    } catch {
      toast.error("Could not exit preview");
    }
  };

  return (
    <div
      className="flex items-center justify-center gap-3 bg-amber-400 px-4 py-1.5 text-sm font-semibold text-amber-950"
      data-testid="impersonation-banner"
    >
      <Eye size={15} />
      <span>
        Access preview — viewing as <strong>{user?.name || user?.email}</strong> ({user?.role})
      </span>
      <button
        onClick={exit}
        data-testid="exit-impersonation"
        className="flex items-center gap-1 rounded-sm bg-amber-950/15 px-2.5 py-0.5 text-xs font-bold uppercase tracking-wide hover:bg-amber-950/25"
      >
        <X size={12} /> Exit
      </button>
    </div>
  );
};
